import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * CustomHook to fire an action when route change starts
 * @param {function(url,shalow)} actionOnRoute arg0:  changed route url, arg1: if shallow route change
 */
export const useRouterChangeStart = (actionOnRoute) => {
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = (url, { shallow }) => {
      actionOnRoute(url, shallow);
      // console.log(
      //     `App is changing to ${url} ${
      //         shallow ? "with" : "without"
      //     } shallow routing`,
      // );
    };
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []);
};
